export const workOrderZh = {
  workOrder: {
    add: '点击添加',
    back: '返回',
    me: '我',
    Customer: '咨询客服',
    Successfully: '提交评价成功!',
    Comments: '意见反馈',
    Submit: '提交',
    Confirm: '确认',
    Cancel: '取消 ',
    tip: '提示',
    activity: '咨询活动',
    selectActivity: '请选择活动',
    selectActivity2: '请选择咨询活动',
    messageUs: '留言咨询',
    ticketStatus: '咨询状态',
    all: '全部',
    inProgress: '咨询中',
    closed: '已结束 ',
    Resolved: '已解决 ',
    unResolved: '未解决 ',
    close: '关闭 ',
    Feedback: '评价 ',
    ViewFeedback: '查看评价',
    CloseTicket: '结束咨询 ',
    newTicket: '发起咨询',
    TicketContent: '咨询内容',
    ticketID: '咨询编号',
    ReplyToTicket: '咨询回复',
    ticketType: '咨询类型',
    submittedAt: '提交时间',
    action: '操作',
    view: '查看/回复',
    ViewTicket: '查看咨询',
    SelectTicketType: '请选择咨询类型',
    Details: '咨询内容',
    tips1: '用户每天最多可发起10条留言咨询...',
    tips2: '请填写您要咨询或反馈的内容... ',
    tips3: '支持上传图片、视频、文档等文件(最多50M)',
    tips4: '请输入你要咨询的内容',
    tips5: '最多可上传9个附件',
    tips6: '是否结束当前咨询？',
    tips7: '本次咨询问题是否已解决？',
    tips8: '请为本次咨询打分',
    tips9: '你的宝贵的意见反馈将会是我们改进的方向～',
    tips10: '请填写意见反馈～',
    tips11: '请选择本次咨询问题是否已解决？',
    tips12: '请为本次咨询打分',
    tips13: '请输入回复内容',
    tips14: '当前咨询已结束，请你为本次咨询做出评价',
    tips15: '你提交的留言咨询得到了回复... ',
    tips16: '填写用户反馈需要登录账号～',
    tips17: '不支持上传此文件类型',
    tips18: '如有需要请点击发起咨询按钮来联系我们～',
    tips19: '提交成功，感谢您的反馈，后续回复可在留言咨询处查看。',
    tips20: '请填写您要咨询或反馈的内容，我们将在工作日尽快回复您',
    tips21: '前往留言咨询',
    tips22: '文件不能大于50M',
    tips23: '请输入你要继续提问或回复的内容...',
    tips24: '咨询客服将会在工作日内尽快回复，请耐心等候～',
    tips25: '正在上传…'
  }
}
export const workOrderEn = {
  workOrder: {
    add: 'Add',
    back: 'Back',
    me: 'Me',
    Customer: 'Customer Service',
    Successfully: 'Successfully !',
    Submit: 'Submit',
    Comments: 'Comments',
    Confirm: 'Confirm',
    Cancel: 'Cancel ',
    tip: 'Tips',
    activity: 'Activity',
    selectActivity: 'Select Activity',
    selectActivity2: 'Select Activity',
    messageUs: 'Message Us',
    ticketStatus: 'Ticket Status',
    all: 'All',
    inProgress: 'In Progress',
    closed: 'Closed',
    Resolved: 'Resolved ',
    unResolved: 'Unresolved ',
    close: 'Close ',
    Feedback: 'Feedback ',
    ViewFeedback: 'View Feedback',
    CloseTicket: 'Close Ticket ',
    newTicket: 'New Ticket',
    TicketContent: 'Ticket Content',
    ticketID: 'Ticket ID',
    ReplyToTicket: 'Reply to Ticket',
    ticketType: 'Ticket Type',
    submittedAt: 'Submitted At',
    action: 'Action',
    view: 'View/Reply',
    ViewTicket: 'View Ticket',
    SelectTicketType: 'Select Ticket Type',
    Details: 'Details',
    tips1: 'Limit: 10 messages/day. Try again tomorrow....',
    tips2: 'Describe your issue or feedback... ',
    tips3: 'Supports images/videos/documents (max 50MB/file)...',
    tips4: 'Describe your issue',
    tips5: 'Max 9 attachments',
    tips6: 'Close this ticket?',
    tips7: 'Was your issue resolved?',
    tips8: 'Rate your experience',
    tips9: 'Your feedback helps us improve',
    tips10: 'Leave comments',
    tips11: 'Was your issue resolved?',
    tips12: 'Rate your experience',
    tips13: 'Type your reply',
    tips14: 'This ticket is closed. Please rate your experience',
    tips15: 'You have a new reply! View now...',
    tips16: 'Sign in to submit feedback',
    tips17: 'This file type is not supported.',
    tips18: 'Click \'New Ticket\' to contact us if needed!',
    tips19: 'Thank you! Your feedback has been submitted. You can check for replies in the \'Message Us\' section.',
    tips20: 'Please describe your issue or feedback. We will get back to you during business days.',
    tips21: 'Message Us',
    tips22: 'The file size cannot exceed 50MB',
    tips23: 'Type your follow-up question or reply here...',
    tips24: 'Thank you for your patience. We will reply during business days.',
    tips25: 'Uploading…'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/workOrder/index.js